import { z } from "zod";
import { ColumnSchema, ViewSchema, ViewType } from "./views";

export enum TransactionCategoryColumn {
    NAME = "name",
    DESCRIPTION = "description",
    GL_MAPPING = "glMapping",
    PERCENTAGE = "percentage",
    TRANSACTIONS = "transactions",
    ACTIONS = "actions",
}

const NameColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionCategoryColumn.NAME),
});

const DescriptionColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionCategoryColumn.DESCRIPTION),
});

const GlMappingColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionCategoryColumn.GL_MAPPING),
});

const PercentageColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionCategoryColumn.PERCENTAGE),
});

const TransactionsColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionCategoryColumn.TRANSACTIONS),
});

const ActionsColumnSchema = ColumnSchema.extend({
    id: z.literal(TransactionCategoryColumn.ACTIONS),
});

export const TransactionCategoriesViewSchema = ViewSchema.extend({
    type: z.literal(ViewType.TRANSACTION_CATEGORIES),
    columns: z.array(
        z.discriminatedUnion("id", [
            NameColumnSchema,
            DescriptionColumnSchema,
            GlMappingColumnSchema,
            PercentageColumnSchema,
            TransactionsColumnSchema,
            ActionsColumnSchema,
        ]),
    ),
});

export type TransactionCategoriesView = z.infer<
    typeof TransactionCategoriesViewSchema
>;
